import { useState, useCallback } from 'react';

interface GeolocationState {
  loading: boolean;
  error: string | null;
}

export function useGeolocation() {
  const [state, setState] = useState<GeolocationState>({ loading: false, error: null });

  const getCurrentPosition = useCallback((): Promise<{ lat: number; lng: number }> => {
    return new Promise((resolve, reject) => {
      if (!navigator.geolocation) {
        const err = 'Geolocation is not supported by your browser';
        setState({ loading: false, error: err });
        reject(err);
        return;
      }

      setState({ loading: true, error: null });

      navigator.geolocation.getCurrentPosition(
        (position) => {
          setState({ loading: false, error: null });
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          const msg = error.code === error.PERMISSION_DENIED
            ? 'Location permission denied'
            : 'Unable to get your location';
          setState({ loading: false, error: msg });
          reject(msg);
        },
        { enableHighAccuracy: true, timeout: 10000 }
      );
    });
  }, []);

  return { ...state, getCurrentPosition };
}
